/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UsersWithOrdersInfo,
    UsersWithOrdersInfoFromJSON,
    UsersWithOrdersInfoFromJSONTyped,
    UsersWithOrdersInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface UsersWithOrdersInfoDataFrame
 */
export interface UsersWithOrdersInfoDataFrame {
    /**
     * 
     * @type {number}
     * @memberof UsersWithOrdersInfoDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof UsersWithOrdersInfoDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof UsersWithOrdersInfoDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<UsersWithOrdersInfo>}
     * @memberof UsersWithOrdersInfoDataFrame
     */
    data: Array<UsersWithOrdersInfo>;
}

export function UsersWithOrdersInfoDataFrameFromJSON(json: any): UsersWithOrdersInfoDataFrame {
    return UsersWithOrdersInfoDataFrameFromJSONTyped(json, false);
}

export function UsersWithOrdersInfoDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsersWithOrdersInfoDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(UsersWithOrdersInfoFromJSON)),
    };
}

export function UsersWithOrdersInfoDataFrameToJSON(value?: UsersWithOrdersInfoDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(UsersWithOrdersInfoToJSON)),
    };
}


